import { action } from 'typesafe-actions';
import { Types } from './types';

export const appendToModalPriority = (priority: number) =>
  action(Types.APPEND_MODAL_PRIORITY, { priority });

export const removeFromModalPriority = (priority: number) =>
  action(Types.REMOVE_MODAL_PRIORITY, { priority });
